var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home antialiased font-sans  bg-gray-100 h-full" },
    [
      _c("Topbar", {
        on: {
          showOnboarding: function($event) {
            _vm.showOnboardingModal = true
          }
        }
      }),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }